.removeShortlistedItem {
  height: 20px;
  width: 20px;
  margin-bottom: 10px;
  border: none;
  border-radius: 30px;
  padding: 0;

  svg {
    height: 20px;
    width: 20px;
    margin: 3px;
    fill: var(--paletteBlue0);
  }
}

.interested {
  display: block;
  margin-top: var(--spacingMd);
  opacity: 0.5;
}

.root {
  display: flex;
  flex-direction: column;
}

.labelAndIcons {
  display: flex;
  gap: var(--spacingSm);
  align-items: center;
  justify-content: end;
}
